import { ApiError } from '@molt/shared';

/**
 * What the route-level error boundary (`components/shell/RouteError.tsx`)
 * shows for whatever the crashed route threw.
 *
 * `ApiError.message` is already member-facing text — `api.ts`'s own doc
 * comment establishes that the client and the server "agree on what an
 * error *is*", so a request that failed with an `ApiError` can show that
 * message directly.
 *
 * Anything else — a render bug, `TypeError: Cannot read properties of
 * undefined`, a third-party throw — is **not** shown verbatim. Those
 * messages are written for a developer's console, not a member's screen,
 * and can leak implementation detail the product has no business
 * disclosing. One honest, generic sentence stands in for all of them.
 */
export function routeErrorMessage(error: unknown, generic: string): string {
  if (error instanceof ApiError && error.message) {
    return error.message;
  }
  return generic;
}
